import React, {FunctionComponent, useEffect, useState} from 'react';
import {ClearIcon, SearchIcon} from '@treez-ui/core/icons';
import useDebounce from '~/lib/useDebounce';

interface Props {
    debounceDuration?: number;
    searchTerm?: string;
    setSearchTerm: (value: string) => void;
    placeholder?: string;
}

const DEFAULT_PLACEHOLDER = 'Search';
const DEFAULT_DEBOUNCE_DURATION = 250;

export const SearchBar: FunctionComponent<Props> = (props: Props) => {
    const {
        debounceDuration = DEFAULT_DEBOUNCE_DURATION,
        searchTerm,
        setSearchTerm,
        placeholder = DEFAULT_PLACEHOLDER,
    } = props;

    const [active, setActive] = useState(false);
    const [searchValue, setSearchValue] = useState<string>(searchTerm || '');

    useEffect(() => {
        if (searchTerm) {
            setSearchValue(searchTerm);
        } else if (!searchTerm && searchValue != null) {
            setSearchValue('');
        }
    }, [searchTerm]);

    const debounceSearch = useDebounce(searchValue, debounceDuration);

    useEffect(() => {
        setSearchTerm(debounceSearch);
    }, [debounceSearch]);

    const clearInputValue = () => {
        setSearchValue('');
    };

    const handleInput = (inputSearchTerm) => {
        setSearchValue(inputSearchTerm);
    };

    const handleInputChange = (event) => {
        handleInput(event.target.value);
    };

    return (
        <div className={`search-bar ${active ? 'active' : ''}`} onClick={() => setActive(true)}>
            <SearchIcon />
            <input
                onChange={handleInputChange}
                placeholder={placeholder}
                type="text"
                value={searchValue}
                key="search-input"
            />
            {active && (
                <button className="search-bar-clear-button" onClick={clearInputValue}>
                    <ClearIcon />
                </button>
            )}
        </div>
    );
};

export default SearchBar;
